import type { TUseRequestUpdaterProps } from 'features/request/useRequest';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractObjectCreateInput, UerCreateWorkOrderChangeObjectMutation } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerCreateWorkOrderChangeObjectGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerCreateWorkOrderChangeObject';

export const useUerCreateWorkOrderChangeObject = (
    workOrderChangeId?: number,
    onSuccess?: (newObjectId?: number) => void,
) => {
    const dispatch = useDispatch();

    const [uerCreateWorkOrderChangeObjectReset] = useResetStoreData({ requestId });

    const onCreateSuccess = useCallback(
        (depsVars: TUseRequestUpdaterProps<UerCreateWorkOrderChangeObjectMutation>) => {
            uerCreateWorkOrderChangeObjectReset(undefined);
            onSuccess?.(depsVars.payload.uerCreateWorkOrderChangeObject?.id);
        },
        [onSuccess, uerCreateWorkOrderChangeObjectReset],
    );

    const [, uerCreateWorkOrderChangeObjectStatus, , uerCreateWorkOrderChangeObjectRequest] = useRequest({
        requestId,
        query: uerCreateWorkOrderChangeObjectGql,
        withEffect: false,
        dependenciesUpdater: onCreateSuccess,
    });

    const uerCreateWorkOrderChangeObjectMakeRequest = useCallback(
        (input: ContractObjectCreateInput) => {
            dispatch(uerCreateWorkOrderChangeObjectRequest({ workOrderChangeId, input }));
        },
        [dispatch, uerCreateWorkOrderChangeObjectRequest, workOrderChangeId],
    );

    useEffect(() => {
        uerCreateWorkOrderChangeObjectReset(undefined);
    }, [uerCreateWorkOrderChangeObjectReset]);

    return {
        uerCreateWorkOrderChangeObjectStatus,
        uerCreateWorkOrderChangeObjectMakeRequest,
    };
};
